import { IImageData, URL } from "../interfaces/layouts";

export default function getURLToImageData (url: URL | string ) : Promise<IImageData> { 
    return new Promise((resolve, reject) => {
        const img: HTMLImageElement = new Image();
        img.onload = () => resolve({
            src:img.src, 
            width: img.naturalWidth,
            height: img.naturalHeight,
            aspect: img.naturalWidth / img.naturalHeight
        });
        img.onerror = (err) => reject(err);
        img.src = url.toString();

    });
}